import React, { useState, useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'aos/dist/aos.css';
import 'glightbox/dist/css/glightbox.min.css';
import Footer from '../components/Footer';
import Header from '../components/Header';



const ContactPage = () => {

  useEffect(() => {
    if (typeof window.AOS !== 'undefined') {
      window.AOS.init({
        duration: 1000,
        easing: 'ease-in-out',
        once: true,
        mirror: false
      });
    }
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  
  const [formStatus, setFormStatus] = useState({
    loading: false,
    error: '',
    success: false
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormStatus({ loading: true, error: '', success: false });
    
    // Simulate form submission
    setTimeout(() => {
      // Here you would normally make an API call to your backend
      



      // For demo purposes, we'll just simulate a successful submission
      setFormStatus({ loading: false, error: '', success: true });
      setFormData({ name: '', email: '', subject: '', message: '' });
    }, 1500);
  };

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    // Newsletter subscription logic would go here
    alert('Newsletter subscription functionality would be implemented here');
  };

  return (
    <main className="main">
      
        <link rel="canonical" href="https://www.zaoafrika.co.ke/" />
        <title>Zao Afrika | Empowering Farmers, Growing Futures</title>
        <meta
          name="description"
          content="Zao Afrika empowers farmers through organic farming, value addition, and access to premium markets. Discover our contract farming, agri-tech solutions, and high-value crop portfolio"
        />
      

      <Header />

      {/* Page Title */}
      <div className="page-title dark-background" data-aos="fade" style={{ backgroundImage: 'url(assets/img/page-title-bg.webp)' }}>
        <div className="container position-relative">
          <h1>Contact Us</h1>
          <p>We would love to hear from you. Send us a message, and we'll get back to you as soon as possible.</p>
        </div>
      </div>

      {/* Contact Section */}
      <section id="contact" className="contact section">
        <div className="mb-5">
          <iframe 
            style={{width: '100%', height: 400}} 
            src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d610.5231812504824!2d36.84476003135123!3d-1.3095828769746691!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1s%20Enterprise%20Road!5e0!3m2!1sen!2ske!4v1743427332961!5m2!1sen!2ske" 
            frameBorder={0} 
            allowFullScreen
            title="Google Maps Location"
          />
        </div>

        <div className="container">
          <div className="row gy-5 gx-lg-5">
            <div className="col-lg-4">
              <div className="info">
                <h3>Get in touch</h3>
                <p>We'd love to hear from you! Whether you have questions about our services, want to explore collaboration opportunities, or need support, our team is here to help. Get in touch with us using the form below.</p>
                
                <div className="info-item d-flex">
                  <i className="bi bi-geo-alt flex-shrink-0"></i>
                  <div>
                    <h4>Location:</h4>
                    <p>Enterprise Road, Industrial Area, Nairobi</p>
                  </div>
                </div>
                
                <div className="info-item d-flex">
                  <i className="bi bi-envelope flex-shrink-0"></i>
                  <div>
                    <h4>Email:</h4>
                    <p>zaoafrika@gmail.com</p>
                  </div>
                </div>
                
                <div className="info-item d-flex">
                  <i className="bi bi-phone flex-shrink-0"></i>
                  <div>
                    <h4>Call:</h4>
                    <p>+254 759 647 078</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-8">
              <form onSubmit={handleSubmit} className="php-email-form">
                <div className="row">
                  <div className="col-md-6 form-group">
                    <input 
                      type="text" 
                      name="name" 
                      className="form-control" 
                      id="name" 
                      placeholder="Your Name" 
                      required 
                      value={formData.name}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="col-md-6 form-group mt-3 mt-md-0">
                    <input 
                      type="email" 
                      className="form-control" 
                      name="email" 
                      id="email" 
                      placeholder="Your Email" 
                      required 
                      value={formData.email}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                
                <div className="form-group mt-3">
                  <input 
                    type="text" 
                    className="form-control" 
                    name="subject" 
                    id="subject" 
                    placeholder="Subject" 
                    required 
                    value={formData.subject}
                    onChange={handleInputChange}
                  />
                </div>
                
                <div className="form-group mt-3">
                  <textarea 
                    className="form-control" 
                    name="message" 
                    placeholder="Message" 
                    required 
                    value={formData.message}
                    onChange={handleInputChange}
                  />
                </div>
                
                <div className="my-3">
                  {formStatus.loading && <div className="loading">Loading</div>}
                  {formStatus.error && <div className="error-message">{formStatus.error}</div>}
                  {formStatus.success && <div className="sent-message">Your message has been sent. Thank you!</div>}
                </div>
                
                <div className="text-center">
                  <button type="submit" disabled={formStatus.loading}>Send Message</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Call To Action Section */}
      <section id="call-to-action" className="call-to-action section light-background">
        <div className="content">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <h3>Subscribe To Our Newsletter</h3>
                <p className="opacity-50">
                Stay updated with our latest news about chia farming, market insights,
                and agricultural best practices!
                </p>
              </div>
              <div className="col-lg-6">
                <form onSubmit={handleNewsletterSubmit} className="form-subscribe">
                  <div className="form-group d-flex align-items-stretch">
                    <input 
                      type="email" 
                      name="email" 
                      className="form-control h-100" 
                      placeholder="Enter your e-mail"
                      required 
                    />
                    <input 
                      type="submit" 
                      className="btn btn-secondary px-4" 
                      value="Subscribe" 
                    />
                  </div>
                  <div className="loading d-none">Loading</div>
                  <div className="error-message"></div>
                  <div className="sent-message d-none">
                    Your subscription request has been sent. Thank you!
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
        
        
        {/* Footer */}
        <Footer />

    </main>
  );
};

export default ContactPage;